import * as THREE from 'three';
import { BaseModule } from '../base/BaseModule';

const countertopOverhang = 0.2;
const countertopHeight = 0.04;
export class KitchenModule extends BaseModule {
  constructor(moduleData, moduleType, sceneManager, cabinet = null) {
    super(moduleData, moduleType, sceneManager);

    // Kitchen-specific properties
    this.cabinetType = moduleType; // lower, upper, ceiling
    // this.doorType = moduleData?.doorType || "swing";
    // this.beveled = moduleData?.beveled || false;
    this.handleType = moduleData.handleType || 'standard';
    this.material = moduleData.material || 'wood';
    this.color = moduleData.color || '#ffffff';
    this.cabinet = cabinet; // Reference to parent cabinet
    this.thumbnail_url =
      moduleData.thumbnail_url ||
      'https://img.freepik.com/free-psd/3d-rendering-furniture-icon_23-2151445358.jpg';

    // Kitchen constraints
    this.constraints = this.getConstraints();
  }

  getConstraints() {
    return {
      groundOffset: 0,
      upperOffset: 500,
      ceilingOffset: 0,
      typePriorities: {
        lower: 1,
        upper: 2,
        ceiling: 3,
      },
      typeHeights: {
        lower: 870,
        upper: 800,
        ceiling: 400,
      },
    };
  }

  // Override load để tính vị trí kitchen-specific
  async load(yPosition) {
    await super.load();

    // Tính vị trí dựa trên kitchen constraints
    const calculatedTransform = this.calculateKitchenPosition(yPosition);
    this.setPosition(calculatedTransform.position);
    this.setRotation(calculatedTransform.rotation);

    return this.group;
  }
  scaleModuleWithFormular(mdDimensions = {}, mdOptions = {}) {
    // // Tìm và xóa tất cả SINGLE_COUNTERTOP hoặc SINGLE_BACKSPLASH cũ nếu có
    // const lstRemoveScenes = this.group.children.filter(
    //   (child) =>
    //     child.userData &&
    //     (child.userData.name === "SINGLE_COUNTERTOP" ||
    //       child.userData.name === "SINGLE_BACKSPLASH")
    // );

    // // Xóa tất cả các phần tử tìm được
    // lstRemoveScenes.forEach((scene) => {
    //   this.group.remove(scene);

    //   // Dispose geometry và material để tránh memory leak
    //   if (scene.geometry) {
    //     scene.geometry.dispose();
    //   }
    //   if (scene.material) {
    //     if (Array.isArray(scene.material)) {
    //       scene.material.forEach((mat) => mat.dispose());
    //     } else {
    //       scene.material.dispose();
    //     }
    //   }
    // });

    super.scaleModuleWithFormular(mdDimensions, mdOptions);
  }

  // Helper methods để tách logic
  optimizeGeometry(geometry) {
    geometry.computeVertexNormals();
    geometry.computeBoundingBox();
    geometry.computeBoundingSphere();
  }

  calculateKitchenPosition(yPosition) {
    // Tính X, Z position với logic mới
    const { position, rotation } = this.findOptimalPosition(yPosition);

    return {
      position: new THREE.Vector3(position.x, yPosition, position.z),
      rotation: rotation,
    };
  }

  // Kitchen-specific methods
  openDoor() {
    if (this.doorType === 'swing') {
      // Animation để mở cửa
    }
  }

  closeDoor() {
    if (this.doorType === 'swing') {
      // Animation để đóng cửa
    }
  }

  changeMaterial(material) {
    this.material = material;
    // Update 3D model material
    if (this.group) {
      // Logic thay đổi material
    }
  }

  // Get data để serialize - override để thêm kitchen properties
  getData() {
    return {
      ...super.getData(),
      doorType: this.doorType,
      handleType: this.handleType,
      material: this.material,
      color: this.color,
    };
  }
}
